import { Link } from "react-router-dom";
import DataModule from "@/components/DataModule";
import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";

export default function Projects() {
  return (
    <DataModule
      title="Projects"
      subtitle="Track interior, contracting & installation projects · Click a project to manage work orders and measurements"
      endpoint="projects"
      pageTestId="projects-page"
      initialRecord={{ status: "Planning", progress: 0 }}
      fields={[
        { key: "name", label: "Project Name", required: true },
        { key: "customer_name", label: "Customer" },
        { key: "site_address", label: "Site Address", type: "textarea", full: true },
        { key: "status", label: "Status", type: "select", options: ["Planning", "In Progress", "On Hold", "Completed", "Cancelled"] },
        { key: "start_date", label: "Start Date", type: "date" },
        { key: "end_date", label: "End Date", type: "date" },
        { key: "budget", label: "Budget", type: "number" },
        { key: "material_cost", label: "Material Cost", type: "number" },
        { key: "labour_cost", label: "Labour Cost", type: "number" },
        { key: "progress", label: "Progress %", type: "number" },
        { key: "assigned_to", label: "Assigned To" },
        { key: "notes", label: "Notes", type: "textarea", full: true },
      ]}
      columns={[
        {
          key: "name",
          label: "Project",
          render: (p) => (
            <Link to={`/projects/${p.id}`} className="font-medium hover:text-primary hover:underline" data-testid={`project-link-${p.id}`}>
              {p.name}
            </Link>
          ),
        },
        { key: "customer_name", label: "Customer" },
        {
          key: "status",
          label: "Status",
          render: (p) => <Badge variant={p.status === "Completed" ? "default" : "secondary"}>{p.status}</Badge>,
        },
        {
          key: "progress",
          label: "Progress",
          render: (p) => (
            <div className="flex items-center gap-2 min-w-[120px]">
              <Progress value={p.progress || 0} className="h-1.5 flex-1" />
              <span className="text-xs text-muted-foreground w-9 text-right">{p.progress || 0}%</span>
            </div>
          ),
        },
        { key: "budget", label: "Budget" },
      ]}
    />
  );
}
